<app-site-settings-menu>
    <div class="work-rotation-page">
        <header class="page-header">
            <button mat-icon-button class="back-button" appPreventDoubleClick (throttledClick)="navigateBack()" [attr.aria-label]="'BackToWorkRotations' | translate: {Default: 'Back to work rotations'}" [matTooltip]="'BackToWorkRotations' | translate: {Default: 'Back to work rotations'}">
                <mat-icon class="material-icons-outlined" aria-hidden="true">arrow_back</mat-icon>
            </button>

            <div class="title-block">
                <span class="eyebrow" appLocalizationPopupDirective localizationCode="WorkRotation">{{ 'WorkRotation' | translate: {Default: "Work Rotation"} }}</span>
                <h1 appLocalizationPopupDirective localizationCode="EditWorkRotation" *ngIf="workRotationId">
                    {{ 'EditWorkRotation' | translate: {Default: "Edit Work Rotation"} }}
                </h1>
                <h1 appLocalizationPopupDirective localizationCode="CreateNewWorkRotation" *ngIf="!workRotationId">
                    {{ 'CreateNewWorkRotation' | translate: {Default: "Create New Work Rotation"} }}
                </h1>
            </div>

            <div class="header-actions">
                <span class="save-state" *ngIf="form?.dirty">
                    <span class="dot"></span>
                    {{ 'UnsavedChanges' | translate: {Default: "Unsaved changes"} }}
                </span>
                <button class="rounded-button" mat-stroked-button appPreventDoubleClick (throttledClick)="navigateBack()">
                    {{ 'Close' | translate: {Default: "Close"} }}
                </button>
                <button class="rounded-button" mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="isLoading || !form?.valid">
                    {{ 'Save' | translate: {Default: "Save"} }}
                </button>
            </div>
        </header>

        <ng-container *ngIf="isLoading; else loaded">
            <div class="main-content">
                <section class="surface-card">
                    <ngx-skeleton-loader count="5" [theme]="{ 'height.px': 56, 'border-radius': '12px' }"></ngx-skeleton-loader>
                </section>
                <section class="surface-card">
                    <ngx-skeleton-loader count="2" [theme]="{ 'height.px': 48, 'border-radius': '10px' }"></ngx-skeleton-loader>
                </section>
            </div>
        </ng-container>

        <ng-template #loaded>
            <div class="main-content" [class.has-side]="workRotationId" [formGroup]="form">
                <div class="primary-column">
                    <!-- Details -->
                    <section class="surface-card">
                        <header class="card-header">
                            <div class="card-icon">
                                <mat-icon class="material-icons-outlined" aria-hidden="true">badge</mat-icon>
                            </div>
                            <div class="card-copy">
                                <h2 appLocalizationPopupDirective localizationCode="WorkRotationName">{{ 'WorkRotationName' | translate: {Default: "Work Rotation Name"} }}</h2>
                                <p>{{ 'WorkRotationNameHint' | translate: {Default: "Add a translation for each language your users see."} }}</p>
                            </div>
                        </header>

                        <app-localization-text-form-field
                            [formElement]="{ formControl: 'localizations', localizationValueParam: 'text', text: ('WorkRotationName' | translate: {Default: 'Work Rotation Name'}), disabled: 'false' }"
                            [parentGroup]="form"
                            [cultures]="allCultures"
                            [hideUsedCultures]="true"
                            [showTitle]="false"
                            (emitAddtoFormArray)="addNewLocalization()"
                            (emitDeleteFromFormArray)="deleteLocalization($event.index)"
                        ></app-localization-text-form-field>
                    </section>

                    <!-- Schedule -->
                    <section class="surface-card schedule-card">
                        <header class="card-header">
                            <div class="card-icon">
                                <mat-icon class="material-icons-outlined" aria-hidden="true">event_repeat</mat-icon>
                            </div>
                            <div class="card-copy">
                                <h2 appLocalizationPopupDirective localizationCode="WorkWeeks">{{ 'WorkWeeks' | translate: {Default: "Work weeks"} }}</h2>
                                <p>{{ 'WorkWeeksDescription' | translate: {Default: "Weeks repeat in order. Leave a day's times empty to make it a day off."} }}</p>
                            </div>
                        </header>

                        <div class="weeks" formArrayName="workWeeks">
                            <div class="week" *ngFor="let workWeek of workWeeks.controls; let i = index" [class.expanded]="isWeekExpanded(workWeek)">
                                <div class="week-header" role="button" tabindex="0"
                                    [attr.aria-expanded]="isWeekExpanded(workWeek)"
                                    (click)="toggleWeek(workWeek)"
                                    (keydown.enter)="toggleWeek(workWeek)"
                                    (keydown.space)="toggleWeek(workWeek); $event.preventDefault()">
                                    <mat-icon class="material-icons-outlined chevron" aria-hidden="true">expand_more</mat-icon>

                                    <div class="week-title">
                                        <span class="week-name">{{ 'WorkWeek' | translate: {Default: "Week"} }} {{ i + 1 }}</span>
                                        <span class="week-summary">
                                            {{ 'WorkingDays' | translate: {Default: "Working days"} }}: {{ workingDayCount(workWeek) }}
                                        </span>
                                    </div>

                                    <div class="day-pills" aria-hidden="true">
                                        <span *ngFor="let day of days; let d = index"
                                            class="day-pill"
                                            [class.on]="isWorkDay(workWeek.value[d])"
                                            [matTooltip]="day.code | translate: {Default: day.code}">{{ day.short }}</span>
                                    </div>

                                    <div class="week-actions">
                                        <button mat-icon-button type="button" class="icon-button"
                                            [matTooltip]="'CreateACopy' | translate: {Default: 'Create a copy'}"
                                            [attr.aria-label]="'CreateACopy' | translate: {Default: 'Create a copy'}"
                                            appPreventDoubleClick (throttledClick)="copyWorkWeek(i)" (click)="$event.stopPropagation()">
                                            <mat-icon class="material-icons-outlined" aria-hidden="true">content_copy</mat-icon>
                                        </button>
                                        <button mat-icon-button type="button" class="icon-button danger"
                                            [matTooltip]="'Delete' | translate: {Default: 'Delete'}"
                                            [attr.aria-label]="'Delete' | translate: {Default: 'Delete'}"
                                            appPreventDoubleClick (throttledClick)="deleteWorkWeek(i)" (click)="$event.stopPropagation()">
                                            <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <div class="week-body" *ngIf="isWeekExpanded(workWeek)">
                                    <div class="day-grid-header" aria-hidden="true">
                                        <span>{{ 'Day' | translate: {Default: "Day"} }}</span>
                                        <span>{{ 'StartTime' | translate: {Default: "Start time"} }}</span>
                                        <span>{{ 'EndTime' | translate: {Default: "End time"} }}</span>
                                        <span>{{ 'BreakTimeHours' | translate: {Default: "Break (hrs)"} }}</span>
                                        <span>{{ 'UnpaidBreakTimeHours' | translate: {Default: "Unpaid break (hrs)"} }}</span>
                                        <span>{{ 'WorkingHours' | translate: {Default: "Working hours"} }}</span>
                                        <span></span>
                                    </div>

                                    <app-work-rotation-element-form
                                        *ngFor="let day of days; let d = index"
                                        [form]="workWeek.controls[d]"
                                        [label]="day.code | translate: {Default: day.code}"
                                    ></app-work-rotation-element-form>
                                </div>
                            </div>
                        </div>

                        <button type="button" class="add-week" appPreventDoubleClick (throttledClick)="addNewWorkWeek(); form.markAsDirty()">
                            <mat-icon class="material-icons-outlined" aria-hidden="true">add</mat-icon>
                            {{ 'AddWorkWeek' | translate: {Default: "Add work week"} }}
                        </button>
                    </section>
                </div>

                <aside class="side-column" *ngIf="workRotationId">
                    <!-- Positions using this rotation -->
                    <section class="surface-card">
                        <header class="card-header">
                            <div class="card-icon">
                                <mat-icon class="material-icons-outlined" aria-hidden="true">work_outline</mat-icon>
                            </div>
                            <div class="card-copy">
                                <h2>
                                    {{ 'PositionsUsingThis' | translate: {Default: "Positions using this"} }} {{ 'WorkRotation' | translate: {Default: "Work Rotation"} }}
                                </h2>
                                <p>{{ gridDataResult.total }} {{ 'Positions' | translate: {Default: "positions"} | lowercase }}</p>
                            </div>
                        </header>

                        <ng-container *ngIf="positionsLoading && gridDataResult.data.length === 0; else positionList">
                            <ngx-skeleton-loader count="3" [theme]="{ 'height.px': 40, 'border-radius': '10px' }"></ngx-skeleton-loader>
                        </ng-container>

                        <ng-template #positionList>
                            <ul class="position-list" *ngIf="gridDataResult.data.length > 0; else noPositions" [class.loading]="positionsLoading">
                                <li *ngFor="let position of gridDataResult.data">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">work_outline</mat-icon>
                                    <span>{{ position.name }}</span>
                                </li>
                            </ul>

                            <ng-template #noPositions>
                                <p class="empty-state">{{ 'NoPositionsUsingWorkRotation' | translate: {Default: "No positions use this rotation yet."} }}</p>
                            </ng-template>

                            <div class="pager" *ngIf="gridDataResult.total > pageSize">
                                <span>{{ skip + 1 }}–{{ positionsRangeEnd }} {{ 'Grid-Pager-Of' | translate: {Default: "of"} }} {{ gridDataResult.total }}</span>
                                <button mat-icon-button type="button" class="icon-button" [disabled]="skip === 0 || positionsLoading" (click)="changePositionsPage(-1)" aria-label="Previous page">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_left</mat-icon>
                                </button>
                                <button mat-icon-button type="button" class="icon-button" [disabled]="positionsRangeEnd >= gridDataResult.total || positionsLoading" (click)="changePositionsPage(1)" aria-label="Next page">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">chevron_right</mat-icon>
                                </button>
                            </div>
                        </ng-template>
                    </section>
                </aside>
            </div>
        </ng-template>
    </div>
</app-site-settings-menu>
